export default "__VITE_ASSET__BXRWpuFh__"